import { render, staticRenderFns } from "./IconComponent.vue?vue&type=template&id=ebb7caf8&"
import script from "./IconComponent.vue?vue&type=script&lang=ts&"
export * from "./IconComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebb7caf8')) {
      api.createRecord('ebb7caf8', component.options)
    } else {
      api.reload('ebb7caf8', component.options)
    }
    module.hot.accept("./IconComponent.vue?vue&type=template&id=ebb7caf8&", function () {
      api.rerender('ebb7caf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/IconComponent.vue"
export default component.exports